import { signal } from '@angular/core';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { SurfaceAnalysisSvgComponent } from './surface-analysis-svg/surface-analysis-legend-svg';

export const SURFACE_ANALYSIS_LEGEND: TwcLegendParams = {
  title: 'SURFACE ANALYSIS',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: SurfaceAnalysisSvgComponent },
  legendComponent: TwcLegendComponent
};
